import { set, get, size } from 'global/lib/lodash';
import { reduxStore } from 'index';
import { UserPermission } from '../lib/filter';
import moment from 'moment';

export const Filter = (overrides = {}) => ({
  searchstring: '',
  scorecard_id: 0,
  start_date: null,
  end_date: null,
  realm_type: [], //'division', 'community', 'lot'
  ownership: 'my',
  client_id: null,
  vendor_id: null,

  //any keys that start with _ will be pulled out of the filters
  _sort: {
    sortBy: 'relevance',
  },
  ...overrides,
});

export const TaskFilter = (overrides = {}) => ({
  searchstring: '',
  ownership: 'my',
  realm_type: [],
  status: 'openPending',
  content: 'title',
  client_id: null,
  vendor_id: null,
  age: 0,

  _sort: {
    sortBy: 'updated_at',
  },
  ...overrides,
});

export const UserFilter = (overrides = {}) => ({
  searchstring: '',
  status: 'active',
  permission: [],
  client_id: 0,

  ...overrides,
});

export const EditionsFilter = (overrides = {}) => ({
  searchstring: '',
  status: ['active'],
  courseStatus: [null, [1, 99]],
  edition_id: 0,
  start_date: null,
  end_date: null,
  role: null,

  _sort: {},
  ...overrides,
});

export const StandardsFilter = (overrides = {}) => ({
  searchstring: '',
  scorecard: 0,
  doctypes: ['type1', 'type2', 'type3', 'type4'],
  supersets: ['super1', 'super2', 'super3', 'super4'],

  _sort: {
    sortBy: 0,
  },
  ...overrides,
});

export const buildFilters = (filter = {}, opts = {}) => {
  let filterRet = {};
  let sort = [];
  const extras = {};

  const sState = reduxStore.store.getState();
  const realmId = get(sState, 'auth.realm.id');
  const usersRealm = get(sState, 'auth.user.realm.id');

  for (let k in filter) {
    if (k.startsWith('_')) {
      set(extras, k.replace('_', ''), filter[k]);
    } else {
      let item = filter[k];
      if (item || item === 0) {
        if (Array.isArray(item)) {
          if (item.length > 0) {
            set(filterRet, k, item.join(','));
          }
        } else if (typeof item === 'object' && Object.keys(item).length) {
          //typically we are planning for these to be checkboxes
          const list = [];
          for (let _k in item) {
            const ki = item[_k];
            if (ki) {
              list.push(_k);
            }
          }
          if (list.length > 0) {
            set(filterRet, k, list.join(','));
          }
        } else {
          if (k.indexOf('_date') > -1) {
            const isValid = moment(item).isValid();
            item = isValid ? item : undefined;
          }
          set(filterRet, k, item);
        }
      }
    }
  }

  if (opts.includeRealm && realmId !== undefined) {
    set(filterRet, 'realm', realmId);
  }

  if (opts.includeUsersRealm && usersRealm !== undefined) {
    set(filterRet, 'realm_id', usersRealm);
  }

  if (opts.convertFilterToSort) {
    opts.convertFilterToSort.forEach((fts) => {
      const item = get(filterRet, fts);
      if (item) {
        delete filterRet[fts];
        sort.push(item);
      }
    });
  }

  if (opts.convertName) {
    for (let k in opts.convertName) {
      if (filterRet[k] !== undefined) {
        const val = filterRet[k];
        if (Array.isArray(opts.convertName[k])) {
          // eslint-disable-next-line no-loop-func
          opts.convertName[k].map((str) => {
            filterRet[str] = val;
          });
        } else {
          filterRet[opts.convertName[k]] = val;
        }
        delete filterRet[k];
      }
    }
  }

  if (opts.dontFilter) {
    opts.dontFilter.forEach((df) => {
      delete filterRet[df];
    });
  }

  if (extras.sort) {
    const sortBy = get(extras, 'sort.sortBy');
    if (sortBy !== undefined) {
      sort.push(sortBy);
    }
  }

  if (opts.dontSort) {
    if (typeof opts.dontSort === 'boolean') {
      sort = opts.dontSort ? [] : sort;
    } else if (Array.isArray(opts.dontSort)) {
      sort = sort.filter((s) => opts.dontSort.indexOf(s) === -1);
    }
  }

  if (opts.overrideSort) {
    sort = opts.overrideSort(sort);
  }

  if (opts.overrideFilter) {
    filterRet = opts.overrideFilter(filterRet);
  }

  return {
    filter: filterRet,
    sort: Array.isArray(sort) && !!size(sort) ? sort.join(',') : undefined,
  };
};

export const appPermissionsToServerPermissions = (filter) => {
  if (filter.permission) {
    const sState = reduxStore.store.getState();
    const perms = filter.permission.split(',');
    const paramArr = perms.map(
      (p) =>
        `${get(
          UserPermission.find((up) => up.value === p),
          'match'
        )}.${get(sState, 'auth.user.realm.id')}`
    );
    set(filter, 'name', paramArr.join(','));
  }
};
